import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ColumnContent, ColumnContentLarge, ColumnContentLargeTitle, ColumnContentSmall, ColumnContentSmallTitle } from 'styles/ColumnContent';
import { ContentList, HtmlContent } from 'styles/Layout';
import { Container } from 'styles';
import LayoutContext from 'context/layout';
import Breadcrumb from 'components/layout/breadcrumb/Breadcrumb';
import ReturnButton from 'components/layout/return-button/ReturnButton';
import QuestionItem from 'components/layout/question-item/QuestionItem';
import ArticleFeedback from 'components/layout/article-feedback/ArticleFeedback';
import FaqService from 'services/faqService';
import Loading from 'components/layout/loading/Loading';
import { getCategoryLabel, getUrlCategoryType } from 'utils/appUtils';

const ArticlePage = () => {
    const navigate = useNavigate();
    const { setState } = useContext(LayoutContext);
    const { url, type } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [article, setArticle] = useState();
    const [relatedArticles, setRelatedArticles] = useState([]);

    useEffect(() => {
		setState({ displaySearch: true, isHome: false });
        getRelatedArticles();
	}, []);

    useEffect(() => {
        getArticle();
	}, [url]);

    useEffect(() => {
        setCurrentActive();
	}, [article]);

    const getRelatedArticles = () => {
        const params = { size: 8 };
        const payload = { categoryType: getUrlCategoryType(type) };
        FaqService.getArticles(params, payload)
            .then(({ data }) => setRelatedArticles(() => data.content))
    }

    const getArticle = () => {
        setIsLoading(() => true);
        FaqService.getArticleContent(url)
            .then(({ data }) => setArticle(() => data))
            .catch(() => navigate('/'))
            .finally(() => setIsLoading(() => false))
    }

    const setCurrentActive = () => {
        if (relatedArticles.length === 0) return;

        const index = relatedArticles.findIndex(relatedArticle => relatedArticle.url === url);

        if (index > -1) {
            const current = relatedArticles[index];
            const filtered = relatedArticles.filter(relatedArticle => relatedArticle.url !== current.url);
            setRelatedArticles([current, ...filtered]);
            return;
        }

        setRelatedArticles([article, ...relatedArticles]);
    }

	return (
        <>
            {isLoading ? (<Loading height="300px" />) : (
                <>
                    <Breadcrumb currentPageName={article?.title} />

                    <Container>
                        <ColumnContent>
                            <ColumnContentSmall showAfter>
                                <ColumnContentSmallTitle>{getCategoryLabel(type)}</ColumnContentSmallTitle>
                                <ContentList>
                                    {relatedArticles.map((article, index) => <QuestionItem key={article.id} active={index === 0} url={article.url} title={article.title} type={article.categoryType} />)}
                                </ContentList>
                                <ReturnButton />
                            </ColumnContentSmall>

                            <ColumnContentLarge>
                                <ColumnContentLargeTitle>{article.title}</ColumnContentLargeTitle>
                                <HtmlContent dangerouslySetInnerHTML={{__html: article.content}} />
                                <ArticleFeedback articleId={article.id} />
                            </ColumnContentLarge>
                        </ColumnContent>
                    </Container>
                </>
            )}
        </>
	);
};

export default ArticlePage;